module.exports = __webpack_public_path__ + "img/ohouse.636dbb92.jpg";